__turbopack_context__.v({
  "codeWrapper": "Ms8NyW_codeWrapper",
  "heading": "Ms8NyW_heading",
  "root": "Ms8NyW_root",
});
